import React from 'react';

/** Pinned actions column — stays visible during horizontal scroll (RTL: inline-end edge). */
export const TABLE_STICKY_ACTIONS_CLASS = 'table-sticky-actions';

/** Pinned bulk-select column — opposite edge from actions (RTL: inline-start). */
export const TABLE_STICKY_SELECT_CLASS = 'table-sticky-select';

export function mergeStickyActionsClass(className = '') {
  return `${TABLE_STICKY_ACTIONS_CLASS}${className ? ` ${className}` : ''}`.trim();
}

export function mergeStickySelectClass(className = '') {
  return `${TABLE_STICKY_SELECT_CLASS}${className ? ` ${className}` : ''}`.trim();
}

/** Body/footer cell for row actions — always last column in the row. */
export function QawaemTableStickyActionsTd({
  className = 'px-6 py-4 text-center align-middle',
  children,
  ...rest
}) {
  return (
    <td {...rest} className={mergeStickyActionsClass(className)}>
      {children}
    </td>
  );
}

/** Footer summary cell when actions column needs its own pinned cell. */
export function QawaemTableStickyActionsFooterTd({
  className = 'px-6 py-4 text-center align-middle text-white/70 text-sm',
  children,
  ...rest
}) {
  return (
    <td {...rest} className={mergeStickyActionsClass(className)}>
      {children}
    </td>
  );
}
